import React from "react";
import CountUp from "react-countup";
// import { Rotate, Zoom } from "react-reveal";
import Zoom from "react-reveal/Zoom";
import Rotate from "react-reveal/Rotate";

const Aboutus = () => {
  return (
    <div id="About" className="container-xxl py-4">
      <div className="text-center">
        <h6 className="section-title bg-white text-center text-primary px-3">
          <Zoom left>About Us</Zoom>
        </h6>

        <Zoom right>
          <h1 className="mb-5 subtitle">Welcome to Action Voice</h1>
        </Zoom>
      </div>
      <div className="container">
        <div className="row g-5">
          <div className="col-lg-6" style={{ minHeight: "400px" }}>
            <div className="position-relative test h-100">
              <Rotate left>
                <img
                  className=" img-fluid position-absolute w-100 h-100"
                  src={"images/About_Us_1.jpg"}
                  alt=""
                />
              </Rotate>
            </div>
          </div>
          <div className="col-lg-6 align-items-center d-flex">
            {/* <h5 className="section-title bg-white text-start text-primary pe-3">
              About Us
            </h5>
            <h1 className="mb-4 subtitle">Welcome to Action Voice</h1> */}
            <div>
              <p className="mb-4 abtTxt">
                <Zoom right>
                  Action Voice Studios is an audio-production company based in
                  Mumbai, India. We specialize in various audio-production
                  services such as Audio Description, Dubbing, Voice-over  and
                  language dubs.
                </Zoom>
              </p>
              <p className="mb-4 abtTxt">
                <Zoom right>
                  We have our own 5 state-of-the-art audio recording studios
                  where we have produced enormous hours of
                  dubbing/voice-over/post-production services. With a
                  well-connected community of more than 200 plus Voice-over
                  artists and have worked on over 5000 ad films we make happy
                  associations with our clients every time!
                </Zoom>
              </p>
              <div className="row mb-4 abtTxt">
                <div className="col-sm-6">
                  <p className="mb-0 d-flex align-items-center">
                    <i className="bi bi-check-all aboutText text-primary me-2"></i>
                    <Zoom left>Dubbing</Zoom>
                  </p>
                </div>
                <div className="col-sm-6">
                  <p className="mb-0 d-flex align-items-center">
                    <i className="bi bi-check-all aboutText text-primary me-2"></i>
                    <Zoom left>Voice Over</Zoom>
                  </p>
                </div>
                <div className="col-sm-6">
                  <p className="mb-0 d-flex align-items-center">
                    <i className="bi bi-check-all aboutText text-primary me-2"></i>
                    <Zoom left>Language Dubbing</Zoom>
                  </p>
                </div>
                <div className="col-sm-6">
                  <p className="mb-0 d-flex align-items-center">
                    <i className="bi bi-check-all aboutText text-primary me-2"></i>
                    <Zoom left>Studio Rental</Zoom>
                  </p>
                </div>
                <div className="col-sm-6">
                  <p className="mb-0 d-flex align-items-center">
                    <i className="bi bi-check-all aboutText text-primary me-2"></i>
                    <Zoom left>Language Supervision</Zoom>
                  </p>
                </div>
                <div className="col-sm-6">
                  <p className="mb-0 d-flex align-items-center">
                    <i className="bi bi-check-all aboutText text-primary me-2"></i>
                    <Zoom left>Mixing</Zoom>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className=" container cardhome-pdng rem-pad pr-0 mt-5 ">
        <div className="card-wrap mt-0 justify-content-center">
          <Zoom>
            <div className="booking-card-width">
              <div className="card-innerbx bookingEngine">
                <div className="chmngr-info">
                  <i className="bi bi-person-video2"></i>
                  <span>
                    <CountUp end={300} duration={9} />+
                  </span>
                  <div className="">
                    <span className="cm-label">Clients</span>
                  </div>
                </div>
              </div>
            </div>
          </Zoom>
          <Zoom>
            <div className="booking-card-width">
              <div className="card-innerbx bookingEngine">
                <div className="chmngr-info">
                  <i className="bi bi-journal-code"></i>
                  <span>
                    <CountUp end={5000} duration={9} />+
                  </span>
                  <div className="">
                    <span className="cm-label">Projects</span>
                  </div>
                </div>
              </div>
            </div>
          </Zoom>
          <Zoom>
            <div className="booking-card-width">
              <div className="card-innerbx bookingEngine">
                <div className="chmngr-info">
                  <i className="bi bi-headset"></i>
                  <span>
                    <CountUp end={24} duration={9} />
                  </span>
                  <div className="">
                    <span className="cm-label">Hours Of Supports</span>
                  </div>
                </div>
              </div>
            </div>
          </Zoom>
        </div>
      </div>
    </div>
  );
};

export default Aboutus;
